import { ReportAccessData } from '../../../../../@types';

/** The three per-recipient permission flags, in the order they are shown. */
export const SHARE_PERMISSION_FIELDS = [
  { field: 'canEdit', label: 'Can Edit' },
  { field: 'canCustomizeSearch', label: 'Can Customize Search' },
  { field: 'canCustomizeColumns', label: 'Can Customize Columns' },
] as const;

export type SharePermissionField = (typeof SHARE_PERMISSION_FIELDS)[number]['field'];

/** Strips the audit fields the save endpoints don't accept off a fetched row. */
export const toShareAccessRow = (row: ReportAccessData): ReportAccessData => ({
  id: row.id,
  entityId: row.entityId,
  name: row.name,
  canEdit: row.canEdit,
  canCustomizeColumns: row.canCustomizeColumns,
  canCustomizeSearch: row.canCustomizeSearch,
  isActive: row.isActive,
});

export const newShareAccessRow = (entityId: number, name: string): ReportAccessData => ({
  entityId,
  name,
  canEdit: false,
  canCustomizeColumns: false,
  canCustomizeSearch: false,
  isActive: true,
});

/** Flips one permission on one recipient, leaving every other row untouched. */
export const setPermission = (
  rows: ReportAccessData[],
  entityId: number | undefined,
  field: SharePermissionField,
  checked: boolean
): ReportAccessData[] =>
  rows.map((row) => (row.entityId === entityId ? { ...row, [field]: checked } : row));
